export default {
    SET_LOADING(state, payload) {
        state.loading = payload
    },
    SET_SWITCHING(state, payload) {
        state.switching = payload
    },
    SET_ERROR(state, payload) {
        state.error = payload
    },
    SET_AVAILABLE_PERIODS(state, payload) {
        state.availablePeriods = payload
    },
    SET_SELECTED_PERIOD(state, payload) {
        state.selectedPeriod = payload
    }
}

